<template>
    <div class="bg-white">
        <section class="bg-digiuni-landing relative">
            <div class="absolute top-200px left-0 lg:block hidden">
                <svg width="93" height="81" viewBox="0 0 93 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="232" height="81" rx="40.5" transform="matrix(-1 0 0 1 93 0)" fill="#F93C34" />
                </svg>
                <svg width="48" height="81" viewBox="0 0 48 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="178" height="81" rx="40.5" transform="matrix(-1 0 0 1 48 0)"
                        fill="#F93C34" />
                </svg>
            </div>
            <div class="flex flex-col items-center justify-center pt-[100px] lg:pt-[180px] pb-[60px] gap-[25px]">
                <img src="/img/digiuni.svg" alt="digiuni-app-bg">
                <h1 class="linear-gradient-text text-[32px] leading-[42px] lg:text-[48px] lg:leading-[58px] font-bold">
                    Absolventi a študenti <br>
                    Digitálnej univerzity, získajte <br>
                    Získajte 20% zľavu na <br>
                    DOFFERO
                </h1>
                <p class="text-center text-[#212541] text-[16px] leading-[24px] w-[90%] lg:w-full">
                    <b>Exkluzívna ponuka pre študentov a absolventov Digitálnej univerzity.</b> <br>
                    Vytvárajte profesionálne cenové ponuky a získajte konkurenčnú výhodu na trhu.
                </p>
                <div class="flex flex-col lg:flex-row p-[10px] rounded-[14px] gap-[10px] overflow-hidden linear-gradient-bg">
                    <!-- Left side - discount -->
                    <div
                        class="w-[290px] h-[100px] lg:h-auto linear-gradient-bg-2 rounded-[10px] px-8 py-6 flex flex-col items-center justify-center">
                        <p class="text-white text-[30px] font-bold leading-none">20% zľava</p>
                        <p class="text-white text-[16px] uppercase tracking-wide">Na váš prvý rok</p>
                    </div>
                    <!-- Right side - promo code -->
                    <div class="w-[290px] h-[100px] lg:h-auto bg-white flex flex-col rounded-[10px] items-center justify-center">
                        <p class="linear-gradient-text text-[14px] font-300 uppercase tracking-wide">Promo kód</p>
                        <p class="linear-gradient-text text-[30px] font-bold ">DIGIUNI20</p>
                    </div>
                </div>
            </div>
            <div class="absolute bottom-0 right-0 2xl:w-[400px] xl:w-[300px] lg:w-[250px] w-0">
                <img class="w-full" src="/img/digiuni-dogo.svg" alt="digiuni-app-bg">
            </div>
        </section>
        <section class="py-16 bg-white relative">
            <div class="absolute top-[-50px] left-[100px]">
                <svg width="162" height="81" viewBox="0 0 162 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="162" height="81" rx="40.5" fill="#FED3D3"/>
                </svg>
            </div>
            <div class="absolute top-[100px] left-[50px]">
                <svg width="107" height="81" viewBox="0 0 107 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="107" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
            </div>
            <p class="text-center uppercase tracking-[0.2em] text-[#D73C78] text-[14px] mb-3">
                Prečo je super?
            </p>
            <h2 class="linear-gradient-text text-[44px] leading-[64px] font-bold text-center mb-12">
                Ako postupovať
            </h2>

            <div class="w-full flex flex-col xl:flex-row items-center justify-center lg:gap-[40px] gap-[20px] mb-10 lg:max-w-[1200px] max-w-[1000px] mx-auto">
                <div v-for="(aproch, index) in aproc" :key="aproch.title" class="flex gap-5 xl:w-[290px] sm:w-[400px] w-[300px]">
                    <div
                        class="w-[62px] h-[62px] rounded-[16px] bg-[#F4F4F4] flex items-center justify-center text-[#1F2937] font-bold text-[16px] shadow-sm">
                        {{ index + 1 }}.
                    </div>
                    <div class="w-[270px] flex flex-col gap-2">
                        <h3 class="text-[#1E2438] font-extrabold text-[16px] leading-6">
                            {{ aproch.title }}
                        </h3>
                        <p class="text-[#6B7280] text-[14px] leading-6" v-html="aproch.description"></p>
                    </div>
                </div>
            </div>

            <div class="flex justify-center">
                <a @click="registerWithDiscount"
                    class="linear-gradient-bg text-white font-extrabold uppercase tracking-wide rounded-full px-8 py-4 text-[16px] shadow-md hover:opacity-95 transition">
                    Vytvoriť účet so zľavou
                </a>
            </div>


            <div class="absolute top-[200px] right-[-80px]">
                <svg width="162" height="81" viewBox="0 0 162 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="162" height="81" rx="40.5" fill="#FED3D3"/>
                </svg>
            </div>
            <div class="absolute top-[350px] right-[50px]">
                <svg width="107" height="81" viewBox="0 0 107 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="107" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
            </div>
        </section>
    </div>
</template>

<script>
export default {
data() {
    return {
        aproc: [
            {
                title: 'Registrujte sa',
                description: 'Vytvorte si účet na DOFFERO kliknutím na tlačidlo nižšie'
            },
            {
                title: 'Zadajte promo kód pri platbe',
                description: 'Pri platbe <b>ročného predplatného</b> na platobnej bráne Sripe zadajte váš promo kód <b>DIGIUNI20</b> pre získanie zľavy'
            },
            {
                title: 'Začnite tvoriť',
                description: 'Ihneď začnite tvoriť profesionálne cenové ponuky a získajte marketingovú výhodu pred ostatnými'
            }
        ]
    }
},
methods: {
    registerWithDiscount() {
        // use session storage to store the discount
        sessionStorage.setItem('digiuni_discount', 'true'); 
        window.location.href = '/register';
    }
}
}
</script>

<style lang="scss" scoped>
.linear-gradient-text {
    background: linear-gradient(90deg, #F93C34 0%, #D73C78 47.28%, #C41F5F 75.15%);
    @apply text-center text-white;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.linear-gradient-bg {
    background: linear-gradient(90deg, #F93C34 0%, #D73C78 47.28%, #C41F5F 75.15%);
}

.linear-gradient-bg-2 {
    background: linear-gradient(90deg, #F97774 0%, #E377A0 100%);
}
</style>